<template>
    <table class="table">
        <thead>
            <tr>
                <th>Description</th>
                <th>Create</th>
                <th>View</th>
                <th>Edit</th>
                <th>Delete</th>
                <th>Publishable</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="(p, i) in permissions">
                <td v-html="getName(i)"></td>
                <td v-for="(f, k) in p">
                    <span v-if="typeof excludes[i] !== 'undefined' && excludes[i].indexOf(k) >= 0">
                        -
                    </span>
                    <input type="checkbox" :name="'permissions['+i+']['+k+']'" v-model="permissions[i][k]" v-else />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    components: {draggable},

    props: {
        params: {
            type: Object,
            default: () => ({})
        }
    },

    data: () => ({
        loading: false,
        validationErrors: [],
        statics: [
            {
                name: 'Users',
                value: 'users'
            },
            {
                name: 'Settings',
                value: 'settings'
            },
            {
                name: 'Translations',
                value: 'translations'
            },
            {
                name: 'Groups',
                value: 'groups'
            },
            {
                name: 'Pages',
                value: 'pages'
            },
            {
                name: 'Offers',
                value: 'offers'
            },
            {
                name: 'Services',
                value: 'services'
            },
            {
                name: 'Tyres',
                value: 'tyres'
            },
            {
                name: 'Menus',
                value: 'menus'
            },
            {
                name: 'Forms',
                value: 'forms'
            },
            {
                name: 'Articles',
                value: 'articles'
            },
            {
                name: 'Careers',
                value: 'careers'
            },
            {
                name: 'Quicklinks',
                value: 'quicklinks'
            }
        ],
        excludes: {
            quicklinks: ['publishable'],
            forms: ['create', 'delete', 'publishable'],
            menus: ['create', 'delete', 'publishable'],
            users: ['publishable'],
            settings: ['create', 'view', 'delete', 'publishable'],
            translations: ['create', 'view', 'delete', 'publishable'],
            groups: ['publishable'],
            pages: ['publishable']
        },
        keys: ['create', 'view', 'edit', 'delete', 'publishable'],
        permissions: {},
        resources: []
    }),

    created() {
        this.setup();
    },

    methods: {
        getName(value) {
            for (let key in this.statics) {
                if (this.statics[key].value == value) {
                    return this.statics[key].name;
                }
            }

            return value;
        },

        setup() {
            for(let i in this.statics) {
                let s = this.statics[i];

                this.$set(this.permissions, s.value, {});

                for(let key in this.keys) {

                    const value = typeof this.params[s.value] != 'undefined' && typeof this.params[s.value][this.keys[key]] != 'undefined' ? this.params[s.value][this.keys[key]] : false;

                    this.$set(this.permissions[s.value], this.keys[key], value);
                }
            }

            // if (this.resources.length > 0) {
            //     for (let key in this.resources) {
            //         let resource = this.resources[key];

            //         this.$set(this.permissions, resource.id, {});

            //         for(let key in this.keys) {
            //             const value = typeof this.params[resource.id] != 'undefined' && typeof this.params[resource.id][this.keys[key]] != 'undefined' ? this.params[resource.id][this.keys[key]] : false;

            //             this.$set(this.permissions[resource.id], this.keys[key], value);
            //         }
            //     }
            // }
        },
        // getResources() {
        //     return Admin.request().post('/admin-api/resources')
        //         .then(({data}) => {
        //             this.resources = data.resources;
        //         });
        // }
    },  

    watch: {
        permissions: {
            deep: true,
            handler(data) {
                this.$emit('input', data);
            }
        },
        params: {
            deep: true,
            handler(data) {
                for(let key in data) {
                    if(typeof this.permissions[key] != 'undefined') {
                        for(let index in data[key]) {
                            if(typeof this.permissions[key][index] != 'undefined') {
                                this.permissions[key][index] = data[key][index];
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
    table {
        width: 100%;
    }

    tr {
        width: 100%;
    }

    thead tr th {
        @apply .bg-grey-lighter .px-6 .py-2 .text-sm .border border-grey-light .font-normal .text-black;
    }

    tbody tr td {
        @apply .border border-grey-light .px-4 .py-2;
    }

    tbody tr:nth-child(even) {
        @apply .bg-grey-lighter;
    }

    td, th {
        @apply .align-middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/Permissions.vue